import React, {Component} from 'react';

const jQuery = window.jQuery,
	$ = jQuery;

class FunFactItem extends Component {
	componentDidMount() {
		this.$node = $(this.refs.countNumb);
		this.$node.counterUp();
	}

	render() {
		const {translate, title, icon, counter} = this.props;
		return (
			<div className="col m4 s12 funfact-box">
				<div className="center-align card-panel white">
					<div className="feature-box-outer">
						<div className="funfact-box-inner">
							<div className="clearfix">
								<i className={icon}/>
								<span ref="countNumb" className="num countNumb" data-counterup-time="500"
									  data-counterup-delay="15">
								{counter}
							</span>
							</div>
							<div className="context">
								{translate(title)}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default FunFactItem



// WEBPACK FOOTER //
// ./src/components/elements/FunFactItem.js